import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../App';
interface SidebarProps {
  categories: string[];
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}
export function Sidebar({
  categories,
  activeCategory,
  onSelectCategory
}: SidebarProps) {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className="hidden lg:block sticky top-32 w-48" data-id="element-162">
      <h3 className="font-mono text-sm mb-8 tracking-widest" style={{
      color: isDark ? '#999' : '#666'
    }} data-id="element-163">
        FILTER BY
      </h3>
      <div className="flex flex-col gap-4" data-id="element-164">
        {categories.map(category => <button key={category} onClick={() => onSelectCategory(category)} className={`text-left text-lg transition-all duration-300 relative group flex items-center ${activeCategory === category ? `${isDark ? 'text-white' : 'text-black'} font-bold pl-4` : `${isDark ? 'text-neutral-500 hover:text-white' : 'text-neutral-400 hover:text-black'}`}`} data-id="element-165">
            {activeCategory === category && <motion.span layoutId="activeIndicator" className={`absolute left-0 w-2 h-2 rounded-full ${isDark ? 'bg-white' : 'bg-black'}`} data-id="element-166" />}
            {category}
          </button>)}
      </div>
    </div>;
}